import { render, staticRenderFns } from "./Server.vue?vue&type=template&id=24cf2769&scoped=true&"
import script from "./Server.vue?vue&type=script&lang=js&"
export * from "./Server.vue?vue&type=script&lang=js&"
import style0 from "./Server.vue?vue&type=style&index=0&id=24cf2769&lang=css&scoped=true&"
import style1 from "./Server.vue?vue&type=style&index=1&id=24cf2769&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cf2769",
  null
  
)

export default component.exports